import React from "react";
import {
  Badge,
  ListGroup,
  ListGroupItem,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";

const DEFAULT_BYPASS_MESSAGE = "Auto disposition bypassed at link";

/**
 * Badge for faxes that skipped UI Path / ML auto disposition at UFL link.
 *
 * @param {object} props
 * @param {string[]} [props.responseTypeList] optional detail messages
 * @param {boolean} [props.showInlineMessage] when true, show muted text beside the badge
 *   (Response List header); otherwise use a tooltip (switch timeline)
 */
export default function BypassAutoDispositionBadge({
  responseTypeList,
  showInlineMessage = false,
}) {
  const tooltipItems =
    responseTypeList?.length > 0 ? responseTypeList : [DEFAULT_BYPASS_MESSAGE];

  const badge = (
    <Badge
      pill
      bg="info"
      className="ml-1"
      data-testid="bypass-auto-disposition-badge"
    >
      Bypass Auto Disposition
    </Badge>
  );

  if (showInlineMessage) {
    return (
      <span id="bypass-auto-disposition-result">
        {badge}
        {responseTypeList?.length ? (
          <>
            {" "}
            <small className="text-muted">
              {responseTypeList.join(", ")}
            </small>
          </>
        ) : null}
      </span>
    );
  }

  return (
    <span id="bypass-auto-disposition-result">
      <OverlayTrigger
        placement="right"
        overlay={
          <Tooltip>
            <ListGroup>
              {tooltipItems.map((item) => (
                <ListGroupItem key={item}>{item}</ListGroupItem>
              ))}
            </ListGroup>
          </Tooltip>
        }
      >
        {badge}
      </OverlayTrigger>
    </span>
  );
}
